import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import PopularServices from './PopularServices';

const { Text, Title } = Typography;

const PreLoginDashboard = () => {
  const { t } = useTranslation('home');

  return (
    <>
      <div className="flex flex-col items-center gap-2 bg-secondary-green-100 px-3 py-10">
        <Title className="m-0 text-3xl text-primary-blue-grey-4 lg:text-4.5xl" level={1}>
          {t('healthEServices')}
        </Title>
        <Text className="text-center text-base">{t('manageYoursAndYourFamily')}</Text>
      </div>
      <PopularServices />
    </>
  );
};

export default PreLoginDashboard;
